/* eslint-disable @typescript-eslint/no-explicit-any */
import { PageType } from '@/constants'
import { useNotification } from '@/containers'
import { Meta } from '@/layouts/Meta'
import { Main } from '@/templates/Main'
import { type Post } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import * as pixel from '@/utils/fpixel'
import dayjs from 'dayjs'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
const PostDetail = ({
  postDetail,
  hideMenu,
}: {
  postDetail: Post
  hideMenu: string
}) => {
  const router = useRouter()
  const { systemConfig } = useNotification()
  useEffect(() => {
    pixel.fbqEvent('ViewContent')
  }, [])
  const updatedDescription =
    postDetail &&
    postDetail?.content &&
    Object?.fromEntries(
      Object?.entries(postDetail?.content).map(([lang, html]: any) => [
        lang,
        html.replace(/pico\.vn/g, 'dienmaykho.vn'),
      ])
    )

  return (
    <Main
      meta={
        <Meta
          title={getTranslate(postDetail?.title)}
          description={getTranslate(postDetail?.title)}
          canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
          imageUrl={
            postDetail?.images[0] ||
            systemConfig?.imageWarehousePlaceholder ||
            process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
            ''
          }
        />
      }
      dataHeader={getTranslate(postDetail?.title)}
      pageLayout={PageType.POST}
      btnHome={true}
      hideMenu={hideMenu === 'true'}
      bgColor='#ffffff'
    >
      <div className='postDetail container pt-4 pb-10'>
        <h1 className='text-titleSection font-bold text-dark-400'>
          {getTranslate(postDetail?.title)}
        </h1>
        <span className='mt-[5px] text-titleProduct text-dark-500 italic font-normal'>
          {dayjs(postDetail?.createdAt).format('HH:mm DD/MM/YYYY')}
        </span>
        <div className='mb-2 mt-3 italic text-dark-400'>
          {getTranslate(postDetail?.description)}
        </div>
        <div
          className='main-description break-words leading-5'
          dangerouslySetInnerHTML={{
            __html: getTranslate(updatedDescription),
          }}
        ></div>
      </div>
    </Main>
  )
}

export default PostDetail
